import calendarNotesComponentUrl from './calendarNotesComponent.html';
export default {
  controller: CalendarNotesController,
  controllerAs: 'ctrl',
  bindings: {
    days: '<',
  },
  templateUrl: calendarNotesComponentUrl,
};

function CalendarNotesController(EventCollection) {
  'ngInject';

  const controller = this;

  controller.hasNotes = hasNotes;

  Object.defineProperty(controller, 'notes', {
    get() {
      return EventCollection.notesDict;
    },
  });

  function hasNotes() {
    return controller.days.some((day) => controller.notes[day]);
  }
}
